import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { BenefitInput } from "@core/types";
import * as api from "./api";
import type { BenefitFilter } from "./api";

const listKey = (filter: BenefitFilter) =>
  [
    "portal",
    "benefits",
    filter.active ?? null,
    filter.categoryId ?? null,
  ] as const;

export const useBenefits = (filter: BenefitFilter = {}) =>
  useQuery({
    queryKey: listKey(filter),
    queryFn: () => api.listBenefits(filter),
  });

// Invalida toda variante de filtro de la lista (SPEC-211 no pagina: la
// pantalla siempre trae el catálogo completo y filtra en cliente, mismo
// criterio que `useRewardMutations`).
export function useBenefitMutations() {
  const client = useQueryClient();
  const invalidate = () =>
    client.invalidateQueries({ queryKey: ["portal", "benefits"] });
  return {
    create: useMutation({
      mutationFn: (input: BenefitInput) => api.createBenefit(input),
      onSuccess: invalidate,
    }),
    edit: useMutation({
      mutationFn: ({ id, input }: { id: string; input: BenefitInput }) =>
        api.editBenefit(id, input),
      onSuccess: invalidate,
    }),
    inactivate: useMutation({
      mutationFn: (id: string) => api.inactivateBenefit(id),
      onSuccess: invalidate,
    }),
  };
}
